import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import _get from 'lodash-es/get';
import _noop from 'lodash-es/noop';
import Button from 'sushiweb/Button';
import Layout from 'sushiweb/Layout/Layout';
import H5 from 'sushiweb/Typography/Heading/H5';
import { Download } from 'sushiweb/Icons';
import { P } from 'sushiweb/Typography/Text';
import ChevronLeft from 'sushiweb/Icons/all/ChevronLeft';
import Upload from 'sushiweb/Icons/all/Upload';
import {
  fileDataFormat,
  fileDataSize,
  sampleFileDataFormat,
} from '../../../Onboarding/constants';
import { SampleEmployeeTable } from '../../../common/components/DataTables/components/SampleEmployees';
import {
  ConfirmUpload,
  Footer,
  FooterWrapper,
  FormWrapper,
  RightButton,
} from '../../../Onboarding/components/styles';
import { Container } from '../../../Onboarding/styles';
import Heading from '../../../Onboarding/components/Heading';
// import { EMPLOYEES_ROUTE } from '../../../../constants/routes';
import {
  InstructionText,
  // ProgressBarStyled,
  StyledLayout,
} from '../../../common/styles';
import {
  checkFileTypeSize,
  clearInputValue,
  downloadCSV,
} from '../../../../helpers';
import {
  employeeUploadMsg,
  genericErrorMsg,
  uploadSuccessStatus,
  wrongFormat,
} from '../../../common/components/constants';
import usePolling from '../../../common/utils/usePolling';
import { UploadsContainer } from '../../../UploadStatus/styles';
import { UPLOAD_EMPLOYEES_URL } from '../../../../constants/urls';
import DownloadComponent from '../../../common/components/DownloadComponent/DownloadComponent';

const UploadEmployees = ({
  processId,
  uploadMsg,
  clearUpload,
  uploadEmployees,
  fileUploading,
  fileUploaded,
  setFileUploadMsg,
  showErrorToast,
}) => {
  const history = useHistory();
  const [uploadStatus, setUploadStatus] = useState('');
  const [uploadData, setUploadData] = useState([]);
  const [isPollingStarted, setIsPollingStarted] = useState(false);
  const [pollingFrequency, setPollingFrequency] = useState(2);
  const [file, setFile] = useState(null);
  const [inputDisabled, setInputDisabled] = useState(false);
  const url = UPLOAD_EMPLOYEES_URL;
  const disabled = file !== null;
  const showProgressBar = uploadStatus === '' || uploadStatus === 'completed';

  history.listen(location => {
    if (location.pathname) {
      clearUpload();
    }
  });

  useEffect(() => {
    if (fileUploaded) {
      setIsPollingStarted(true);
      setInputDisabled(true);
    }
  }, [fileUploaded]);

  useEffect(() => {
    if (uploadStatus === 'completed') {
      setIsPollingStarted(false);
    }
  }, [uploadStatus]);

  const TopScroll = () => {
    const successRef = useRef();
    useEffect(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    return <div ref={successRef} />;
  };

  const onResponse = ({ isError, response }) => {
    let message = '';
    const status = _get(response, 'data.status', '');
    const uploads = _get(response, 'data.uploads', []);
    setUploadStatus(status);
    setUploadData(uploads);
    if (uploadSuccessStatus.includes(status)) {
      message = _get(response, 'data.message.title', employeeUploadMsg);
    } else {
      message = _get(response, 'data.message.title', genericErrorMsg);
    }

    if (isError) {
      setIsPollingStarted(false);
      setFileUploadMsg(employeeUploadMsg);
      return;
    }
    setFileUploadMsg(message);
    if (uploadSuccessStatus.includes(status) && !isError) {
      setPollingFrequency(3);
    } else {
      setIsPollingStarted(false);
    }
  };

  const onChange = e => {
    checkFileTypeSize(e.target.files[0])
      .then(success => {
        if (success) {
          setFile(e.target.files[0]);
        } else {
          showErrorToast(wrongFormat);
          clearInputValue();
        }
      })
      .catch(err => {
        clearInputValue();
        showErrorToast();
        console.log(err);
      });
  };

  usePolling({
    processId,
    frequency: pollingFrequency,
    isPollingStarted,
    onResponse,
    url,
  });

  const goBack = () => {
    clearUpload();
    history.goBack();
  };

  const goNext = () => {
    // const fileBody = new FormData();
    // if (groupName) {
    //   fileBody.append('group_id', id);
    //   fileBody.append('file', file);
    // } else {
    //   fileBody.append('name', name);
    //   fileBody.append('file', file);
    // }
    uploadEmployees(file);
  };

  return (
    <>
      {/* <ProgressBarStyled active={fileUploading} /> */}
      <Container>
        <Container.Content>
          {uploadStatus === 'completed' && !isPollingStarted ? (
            <Heading
              heading='Employee Data Upload Completed'
              subheading='Please check the status of the upload below.'
            />
          ) : (
            <Heading
              heading='Upload Employee Data'
              subheading='Please upload and verify the list of employees for your company'
            />
          )}
          {(!showProgressBar || isPollingStarted || fileUploading) && (
            <TopScroll />
          )}
          <ConfirmUpload
            status={uploadStatus}
            progress={isPollingStarted}
            show={!showProgressBar || isPollingStarted || fileUploading}
          >
            {uploadMsg}
          </ConfirmUpload>
          {!['failed', 'completed', 'terminated'].includes(uploadStatus) && (
            <FormWrapper>
              <H5>Upload Employee Details</H5>
              <SampleEmployeeTable />
              <P className='required-field'>Upload employee list</P>
              <StyledLayout>
                <Layout.Item colD={6} colT={6} colM={6}>
                  <input
                    id='upload-file'
                    type='file'
                    accept='.csv'
                    onChange={onChange}
                    disabled={inputDisabled}
                  />
                  <InstructionText>
                    <P>Upload format:</P> {fileDataFormat} | <P>File size:</P>{' '}
                    {fileDataSize}
                  </InstructionText>
                </Layout.Item>
                <Layout.Item colD={6} colT={6} colM={6}>
                  <Button
                    onClick={downloadCSV}
                    icon={<Download />}
                    iconAlign='left'
                    size='large'
                  >
                    Download Sample File
                  </Button>
                  <InstructionText>{sampleFileDataFormat}</InstructionText>
                </Layout.Item>
              </StyledLayout>
            </FormWrapper>
          )}
          {uploadStatus === 'completed' && !isPollingStarted && (
            <UploadsContainer>
              {uploadData.map(uploadInfo => {
                const { title = '', subtitle = '', link = '' } = uploadInfo;
                return (
                  <DownloadComponent
                    title={title}
                    label={subtitle}
                    link={link}
                  />
                );
              })}
            </UploadsContainer>
          )}
        </Container.Content>
      </Container>
      <FooterWrapper>
        <Footer>
          <Button
            appearance='outline'
            icon={<ChevronLeft />}
            iconAlign='left'
            btnColor='red'
            onClick={goBack}
            disabled={fileUploading || isPollingStarted}
          >
            {!['failed', 'completed', 'terminated'].includes(uploadStatus)
              ? 'Go back'
              : 'Done'}
          </Button>
          {uploadStatus === '' && (
            <RightButton
              iconAlign='right'
              icon={<Upload />}
              btnColor='red'
              onClick={goNext}
              disabled={!disabled}
              loading={fileUploading || isPollingStarted}
            >
              Upload
            </RightButton>
          )}
        </Footer>
      </FooterWrapper>
    </>
  );
};

UploadEmployees.propTypes = {
  uploadMsg: PropTypes.string,
  processId: PropTypes.string,
  fileUploading: PropTypes.bool,
  fileUploaded: PropTypes.bool,
  clearUpload: PropTypes.func,
  setFileUploadMsg: PropTypes.func,
  uploadEmployees: PropTypes.func,
  showErrorToast: PropTypes.func,
};

UploadEmployees.defaultProps = {
  processId: '',
  uploadMsg: '',
  clearUpload: _noop,
  setFileUploadMsg: _noop,
  uploadEmployees: _noop,
  fileUploading: false,
  showErrorToast: _noop,
  fileUploaded: false,
};

export default UploadEmployees;
